import { SuspenseLoading } from '@/components/SuspenseErrorBoundary/fallback';
import { useGetAiServiceSetting } from '@/context/services/ai_service_setting/AiServiceSetting.service';
import { FC, Suspense } from 'react';
import { AiServiceSettings } from './AiServiceSettings/AiServiceSettings';
import { InitialSetting } from './InitialSetting/InitialSetting';
import styles from './styles.module.scss';

export const InnerAiServiceSetting: FC = () => {
  const setting = useGetAiServiceSetting();

  if (setting.is_ai_service_agreed) {
    return (
      <AiServiceSettings
        isModelTrainingAllowed={setting.is_model_training_allowed}
        services={setting.ai_service_settings}
      />
    );
  } else {
    return (
      <InitialSetting
        initialIsModelTrainingAllowed={setting.is_model_training_allowed}
        services={setting.ai_service_settings}
      />
    );
  }
};

export const AiServiceSetting: FC = () => (
  <Suspense fallback={<SuspenseLoading className={styles.loadingContainer} />}>
    <InnerAiServiceSetting />
  </Suspense>
);
